import { render, staticRenderFns } from "./LoyaltyPointOverviewMobilePreview.vue?vue&type=template&id=b4b0163a&scoped=true&"
import script from "./LoyaltyPointOverviewMobilePreview.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointOverviewMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointOverviewMobilePreview.vue?vue&type=style&index=0&id=b4b0163a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b0163a",
  null
  
)

export default component.exports